import { createRootRoute } from '@tanstack/react-router';
import { RootLayout } from '@/components/layouts/RootLayout';

export const Route = createRootRoute({
  component: RootLayout,
});

